import { useState, useEffect, useMemo } from 'react'
import theme from '../styles/theme'
import { WidthCategory } from '../typing/enums'
import { UseResponsiveWidthOutput } from '../typing/interfaces'

const useResponsiveWidth = ():UseResponsiveWidthOutput => {
  const [
    windowWidth,
    setWindowWidth,
  ] = useState<number>(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const widthCategory:WidthCategory = useMemo(() => {
    if (windowWidth > parseInt(theme.screens.medium)) {
      return WidthCategory.large
    } else {
      return WidthCategory.medium
    }
  }, [windowWidth])

  return { windowWidth, widthCategory }
}

export default useResponsiveWidth
